import {
GET_DL_SHOWROOM_REQUEST,
GET_DL_SHOWROOM_SUCCESS,
GET_DL_SHOWROOM_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const DlShowroomReport = (token, data) => (dispatch) => {
  dispatch({ type: GET_DL_SHOWROOM_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/StyleWiseDLShowroom`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      gender_id: data.gender_id === "All" ? null : data.gender_id ,
      
      gender_category_id: null,
      sku: data.sku === "All" ? null : data.sku,
      style_id: data.style_id === "All" ? null : data.style_id,
      
      product_status_id: null,
      season_id: data.current_season_id === "All" ? null : data.current_season_id,
      wash_id: data.wash_id === "All" ? null : data.wash_id
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_DL_SHOWROOM_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DL_SHOWROOM_ERROR,
        payload: [],
      });
    });
};
